import React from 'react';
import Button from '@Theme/natucare/components/Button/Button';
import { ctaPropTypes } from './CtaPropTypes';
import * as styles from './Cta.module.scss';
const Cta = ({
  description,
  heading,
  button
}) => {
  if (!heading && !description) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, heading && /*#__PURE__*/React.createElement("div", {
    className: styles.rootHeading
  }, heading), description && /*#__PURE__*/React.createElement("div", {
    className: styles.rootDescription,
    dangerouslySetInnerHTML: {
      __html: description
    }
  }), (button === null || button === void 0 ? void 0 : button.label) && (button === null || button === void 0 ? void 0 : button.href) && /*#__PURE__*/React.createElement(Button, {
    variant: "secondaryLight",
    label: button.label,
    href: button.href,
    classname: styles.rootButton
  }));
};
export default Cta;